import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { AuthModel } from "../../types/auth";
import { getLastVisitPath } from "../../service/setLastPath";

const AuthCallback = () => {
  const [params] = useSearchParams();
  const { loginWithParams } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const name = params.get("name");
    const email = params.get("email");
    const picture = params.get("picture");
    const token = params.get("token");
    const cusId = params.get("cus_id");

    if (name && email && token && cusId) {
      const user: AuthModel = {
        name,
        email,
        picture: picture || "",
        token,
        cusId,
      };

      loginWithParams(user);

      // const lastPath = getLastVisitPath();
      // if (lastPath && lastPath.startsWith("/checkout")) {
      //   navigate(lastPath);
      // } else {

      navigate("/");
    }
    // } else {
    //   // Handle error case (missing params)
    //   console.error("Missing login data from callback URL");
    //   navigate("/");
    // }
  }, []);

  return <div>Logging in...</div>;
};

export default AuthCallback;
